import { Component, ChangeDetectorRef } from '@angular/core'
import { AgFilterComponent } from 'ag-grid-angular'
import { LookupFilterComponent } from './lookup-filter/lookup-filter.component'
import { Option } from '../../app-select/option'

@Component({
  selector: 'app-nullnotnull-filter',
  templateUrl: './lookup-filter/lookup-filter.component.html',
  styleUrls: ['./lookup-filter/lookup-filter.component.scss'],
  standalone: false
})
export class NullNotNullFilterComponent extends LookupFilterComponent implements AgFilterComponent {
  constructor(cdr: ChangeDetectorRef) {
    super(cdr)
    this.items = [new Option('$notnull$', 'Yes', true), new Option('$null$', 'No', false)]
  }

  getModel(): any {
    return this.isFilterActive()
      ? {
          type: this.selectedItem === '$null$' ? 'equals' : 'notequal',
          filter: 'null'
        }
      : null
  }
}
